export const ADD_COMMENT = 'ADD_COMMENT';
export const PLANTS_LOADING = 'PLANTS_LOADING';
export const PLANTS_FAILED = 'PLANTS_FAILED';
export const ADD_PLANTS = 'ADD_PLANTS';
export const ADD_COMMENTS = 'ADD_COMMENTS';
export const COMMENTS_FAILED = 'COMMENTS_FAILED';
export const PROMOS_LOADING = 'PROMOS_LOADING';
export const ADD_PROMOS = 'ADD_PROMOS';
export const PROMOS_FAILED = 'PROMOS_FAILED';
export const LEADERS_LOADING = 'LEADERS_LOADING';
export const ADD_LEADERS = 'ADD_LEADERS';
export const LEADERS_FAILED = 'LEADERS_FAILED';

export const ADD_FEEDBACK = 'ADD_FEEDBACK';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const FAVORITES_LOADING = 'FAVORITES_LOADING';
export const FAVORITES_FAILED = 'FAVORITES_FAILED';

export const ADD_FAVORITES = 'ADD_FAVORITES';
export const ADD_ALLFAV = 'ADD_ALLFAV';
export const ALLFAV_LOADING = 'ALLFAV_LOADING'

export const ADD_UPLOAD = 'ADD_UPLOAD';
export const UPLOAD_LOADING = 'UPLOAD_LOADING';
export const UPLOAD_FAILED = 'UPLOAD_FAILED';
export const ADD_PLANT = 'ADD_PLANT';

export const FILTER_PLANT = 'FILTER_PLANT';

export const ADD_UPDATES = 'ADD_UPDATES';
export const UPDATES_FAILED= 'UPDATES_FAILED';
export const ADD_UPDATE = 'ADD_UPDATE';
export const ADD_PLANTID= 'ADD_PLANTID';

export const RESET_PROPS = 'RESET_PROPS';
export const DATA_SUCCESS = 'DATA_SUCCESS';

export const DATA_SEEN='DATA_SEEN'
